module.exports = __webpack_public_path__ + "static/media/js.7d712814.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/js.png
 ** module id = 1246
 ** module chunks = 0
 **/